import axios from 'axios'
import { database } from "@/modules/ssp_database/database";

export interface IPreviewResponse {
  preview: {
    count: number,
    fields: string[],
    rows: string[][],
  },
  error: string | null,
}

interface IIndexResponse {
  jobs: ICasJob[]
  num_pages: number
}

async function previewJob(release: string, sql: string) {
  return database.login(async (credentials) => {
    const { data } = await axios.post<IPreviewResponse>('/datasearch/skymaps_api/catalog_jobs', {
      preview: true,
      catalog_job: {
        sql,
        release_version: release,
      },
      ...credentials,
    })
    return data
  })
}

async function enqueueJob(release: string, sql: string, noMail: boolean) {
  return database.login(async (credentials) => {
    const { data } = await axios.post(`/datasearch/skymaps_api/catalog_jobs`, {
      catalog_job: {
        sql,
        release_version: release,
      },
      nomail: noMail,
      ...credentials,
    })
    return data
  })
}

async function deleteJob(job: ICasJob) {
  return database.login(async (credentials) =>
    (await axios.delete(`/datasearch/skymaps_api/catalog_jobs/${job.id}`, {
      params: credentials,
    })).data,
  )
}

async function cancelJob(job: ICasJob) {
  return database.login(async (credentials) =>
    (await axios.post(`/datasearch/skymaps_api/catalog_jobs/${job.id}/cancel`, credentials)).data,
  )
}

async function jobIndex(page = 1) {
  return database.login(async () => {
    const { data } = await axios.get<IIndexResponse>(`/datasearch/skymaps_api/catalog_jobs`, {
      params: { per: 50, page },
    })
    return data
  })
}

async function downloadJob(job: ICasJob) {
  return database.login(async () => {
    const { data } = await axios.get<ArrayBuffer>(`/datasearch/skymaps_api/catalog_jobs/${job.id}/download`, {
      responseType: 'arraybuffer',
    })
    return data
  })
}

export interface ICasJob {
  id: number
  name: string
  status: string
  sql: string
  error?: string
  out_format: string
  started_at: string
  finished_at: string
  created_at: string
  updated_at: string
  include_metainfo_to_body: boolean
  download_key: string
  hidden_at: string
  mailto: string
  filesize_at_job_finish: number
  submitted_from: string
  release_version: string
  database: string
  queued_at: string
  compress: boolean
  filesize: number
}

export const cas = {
  previewJob,
  enqueueJob,
  deleteJob,
  cancelJob,
  jobIndex,
  downloadJob,
}
